export const superBigBorderRadius = '40px'
export const bigBorderRadius = '30px'
export const regularBorderRadius = '20px'
export const mediumBorderRadius = '12px'
export const smallBorderRadius = '10px'
export const tinyBorderRadius = '8px'
export const minBorderRadius = '5px'
export const minimumBorderRadius = '2px'
